import type { SubmitPrompt, Taxonomy } from '@promptvault/shared';
import { apiFetch } from './client';

export function fetchTaxonomy(): Promise<Taxonomy> {
  return apiFetch<Taxonomy>('/taxonomy');
}

/**
 * Typed straight off the shared zod schema so the client can't drift from what the Worker
 * validates — the previous hand-written signature had already lost `exampleUrls`.
 */
export function submitPrompt(
  data: SubmitPrompt,
): Promise<{ id: string; status: 'received' | 'duplicate' }> {
  return apiFetch('/submit', {
    method: 'POST',
    body: JSON.stringify(data),
  });
}
